import React, { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import api from "@/lib/api";
import { useCamp } from "@/context/SettingsContext";
import { useLang } from "@/i18n";

export const DemoBanner = ({ refreshKey }) => {
  const { camp } = useCamp();
  const { t } = useLang();
  const [count, setCount] = useState(null);
  const on = camp?.demo_mode;

  useEffect(() => {
    if (!on) { setCount(null); return; }
    api.get("/dummy/count").then((r) => setCount(r.data.total)).catch(() => setCount(null));
  }, [on, refreshKey]);

  if (!on) return null;
  return (
    <div data-testid="demo-banner"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-rose-600 px-4 py-1.5 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-white sm:text-xs print:hidden">
      <span className="flex items-center gap-2">
        <FlaskConical className="h-3.5 w-3.5 shrink-0" />{t("demo_banner")}
      </span>
      {count !== null && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-0.5 tabular-nums"
          data-testid="demo-banner-count">{count} {t("demo_banner_count")}</span>
      )}
    </div>
  );
};
